import React, { useState, useContext, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import useAlertTableQuery from "./useAlertTableQuery.js";
import Button from "components/CustomButtons/Button.js";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import UserService from "services/UserService";
import Chip from "@mui/material/Chip";
import { getAlertDetail, getAlertAcquitment, downloadFile } from "services/ConfigServices";
//import "react-table/react-table.css";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
// @mui/icons-material
import VisibilityIcon from "@mui/icons-material/Visibility";
import Check from "@mui/icons-material/Check";
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import Tooltip from '@mui/material/Tooltip';
import styled from "styled-components";
import ReactLoading from "react-loading";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'assets/css/customNotifications.css';
import AlertDescriptionDialog from "./AlertDescriptionDialog.js";

const useStyles = makeStyles(styles);
const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles2 = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: '16px',
    },
  },
}));
const LinearIndeterminate = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LinearProgress />
    </div>
  );
};

const LoadingDiv = styled.div`
height: 20vh;
width: 20vw;
display: flex;
flex-wrap: nowrap;
align-content: center;
justify-content: center;
padding-top: 10vh;
`;
const CardTitle = styled.h3`

  margin-top: 0.7rem;
  font-size: 1.3rem;
  font-weight: 500;
  font-family: "Source Sans Pro",sans-serif;
`;

const CardSubTitle = styled.h3`
  margin-top: 0.7rem;
  font-size: 1.3rem;
  font-weight: 500;
  font-family: "Source Sans Pro",sans-serif;
  font-style: italic;
`;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0rem 0.9rem 0rem 0.9rem;
  font-family: "Source Sans Pro",sans-serif;
`;
const Data = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
`;
const DataMargin = styled.div`
font-size: 14px;
font-weight: 500;
opacity: 1;
margin-left: 15px;
`;
// const DataResult = styled.div`
//   padding: 0.25rem 0.25rem;
//   font-size: 14px;
//   font-weight: 400;
//   opacity: 1;
//   margin-left: auto;
//   text-align: right;
// `;
const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
`;
const DataResultLink = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
  cursor: pointer;
  text-decoration: underline;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
  margin-bottom: 0.6rem;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const RTAlertes = () => {
  const appContext = useContext(AdvancedSearchContext);
  const { setPage } = appContext;
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const alertsacquit = permis.includes("alerts_acquit");
  const [openAlertDescription, setOpenAlertDescription] = useState(false);
  const { gridState, error, refetch, invalidate, setRefresh, refresh, setData, setAvoidLoading } = useAlertTableQuery();
  const [row, setRow] = useState();
  const [rowClicked, setRowClicked] = useState();

  const [alert, setAlert] = useState(null);
  const hideAlert = () => {
    setAlert(null);
  };

  useEffect(() => {
    setPage('alerts');
  }, []);

  const handleCloseAlertDecription = () => {
    setOpenAlertDescription(false);
  }

  const alertDetail = (row) => async () => {
    let obj = dataEntite.find((o) => o.id === row.id);
    let idSelected = obj.id;

    axios
      .get(
        getAlertDetail(idSelected),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        const rowClickedTmp = res.data;
        setRow(row);
        setRowClicked(rowClickedTmp);
        setOpenAlertDescription(true);
      });
  };

  const alertAcquitment = (row, status) => async () => {

    let obj = dataEntite.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let dataTmp = gridState.data.map((datarow) => {
      if (datarow.id === row.id) {
        console.log("row found");
        datarow.acquited = status;
      }
      return datarow;
    });
    setData(dataTmp);
    setAvoidLoading(true);
    axios
      .post(
        getAlertAcquitment(idSelected, status), {},
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          if (status === 'pending')
            NotificationManager.success("Alerte en cours de traitement");
          else
            NotificationManager.success("Alerte acquitée");
        }
        else
          NotificationManager.error("Une erreur est survenue");
        setRefresh(!refresh);
      }).catch((error) => {
        NotificationManager.error("Une erreur est survenue");
        setRefresh(!refresh);
      });;
  };

  let dataEntite = gridState.data;

  const classes = useStyles();


  if (error) {
    return (
      <p>
        <span role="img" aria-label="Problem">
          🔧
        </span>{" "}
        Something broke... <button onClick={refetch}>Retry</button>
      </p>
    );
  }

  const columns = [
    {
      name: "Début de l'alerte",
      selector: row => row.date,
      key: "date",
      sortable: true,
      width: "8rem",
      cell: (row) => moment(row.date).format("DD/MM/YYYY"),
    },
    {
      name: "Fin de l'alerte",
      selector: row => row.enddate,
      key: "dateend",
      sortable: true,
      width: "8rem",
      cell: (row) =>
        row.enddate ?
          moment(row.enddate).format("DD/MM/YYYY")
          : <></>
    },
    {
      name: "Categorie",
      selector: row => row.category,
      key: "category",
      sortable: true,
      wrap: true,
    },
    {
      name: "Nom",
      selector: row => row.name,
      key: "name",
      sortable: true,
      wrap: true,
    },
    {
      name: "Site",
      selector: row => row.groupname,
      key: "groupname",
      sortable: true,
      width: "10rem",
      wrap: true,
    },
    {
      name: "Criticité",
      selector: row => row.criticity,
      key: "criticity",
      sortable: true,
      width: "10rem",
      // eslint-disable-next-line react/display-name
      cell: (row) =>
        row.criticity == 0 ? (
          <div style={{ color: "#008083", fontWeight: "bold" }}>Information</div>
        ) : row.criticity == 1 ? (
          <div style={{ color: "#E3A322", fontWeight: "bold" }}>Avertissement</div>
        ) : row.criticity == 2 ? (
          <div style={{ color: "#FF8E55", fontWeight: "bold" }}>Important</div>
        ) : (
          <div style={{ color: "#FF432D", fontWeight: "bold" }}>Critique</div>
        ),
    },
    {
      name: "Coût",
      selector: row => row.cost,
      key: "cost",
      sortable: true,
      width: "8rem",
      cell: (row) =>
        row.cost ?
          <div>{row.cost} €</div>
          : <></>
    },
    {
      name: "Statut",
      key: "acquited",
      selector: row => row.acquited,
      sortable: true,
      // width: "10rem",
      cell: (row) =>
        row.acquited === "yes" ? (
          <div>Acquitée le {moment(row.acquitment.date).format("DD/MM/YYYY")}</div>
        ) : row.acquited === "pending" ? (
          <div>En cours de traitement depuis le {moment(row.acquitment.date).format("DD/MM/YYYY")}</div>
        ) : (
          <div>Non traitée</div>
        ),
    },
    {
      name: "Actions",
      sortable: false,
      width: "10rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">

            {alertsacquit ?
              <>
                <Tooltip title="Passer en cours de traitement">
                  <Button
                    onClick={alertAcquitment(row, 'pending')}
                    color={"warning"}
                    className={classes.actionButton}
                    disabled={row.acquited !== "no" ? true : false}
                  >
                    <WatchLaterIcon fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title="Acquiter">
                  <Button
                    onClick={alertAcquitment(row, 'yes')}
                    color={"success"}
                    className={classes.actionButton}
                    disabled={row.acquited !== "yes" ? false : true}
                  >
                    <Check fontSize="large" />
                  </Button>
                </Tooltip>
              </> : <></>
            }
            <Tooltip title="Voir les détails">
              <Button
                onClick={alertDetail(row)}
                color={"info"}
                className={classes.actionButton}
              >
                <VisibilityIcon fontSize="large" />
              </Button>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <div style={{ paddingTop: 10 }}>
       <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          //title="Tableau d'alertes"
          noDataComponent={<NoData>Aucune alerte à afficher</NoData>}
          noHeader={true}
          columns={columns}
          persistTableHead
          sortServer
          pagination
          paginationServer
          paginationPerPage={20}
          
          subHeader
          paginationComponentOptions={
            {
              noRowsPerPage: false,
              rowsPerPageText: "Lignes par page",
              rangeSeparatorText: "sur",
              selectAllRowsItem: false,
              selectAllRowsItemText: "Selectionner toutes les lignes"
            }
          }
          progressPending={gridState.loading}
          progressComponent={<div><LoadingDiv><ReactLoading
            type={"bars"}
            color={"#91c241"}
            height={"10%"}
            width={"10%"}
          /></LoadingDiv></div>}
          {...gridState}
        ></DataTable>
        <Dialog
          onClose={handleCloseAlertDecription}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="md"
          open={openAlertDescription}
        >
          <AlertDescriptionDialog
            row={row}
            rowClicked={rowClicked}
            closeModal={handleCloseAlertDecription}
            refetch={refetch}
          />
        </Dialog>
        <NotificationContainer />
      </div>
    </>
  );
};

export default RTAlertes;
